module.exports = __webpack_public_path__ + "img/right.2cedc70d.svg";